"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactPose = _interopRequireDefault(require("react-pose"));

var _reactMeasure = _interopRequireDefault(require("react-measure"));

var _styledSystem = require("styled-system");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: ew-resize;\n  position: absolute;\n  padding: ", "px;\n  ", ";\n  & > * {\n    transition: box-shadow 250ms ease-in-out;\n  }\n  &:focus {\n    outline: none;\n  }\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MarkerWrapper = (0, _styledComponents["default"])(_reactPose["default"].div({
  draggable: 'x',
  dragBounds: function dragBounds(_ref) {
    var bounds = _ref.bounds;
    return {
      left: bounds.left,
      right: bounds.right
    };
  }
}))(_templateObject(), function (_ref2) {
  var hitSlop = _ref2.hitSlop;
  return hitSlop;
}, function (_ref3) {
  var layout = _ref3.layout,
      hitSlop = _ref3.hitSlop;
  return layout ? {
    left: "-".concat(layout.width / 2 + hitSlop, "px")
  } : {
    opacity: 0
  };
}, _styledSystem.zIndex);
var ARROW_RIGHT = 39;
var ARROW_UP = 38;
var ARROW_LEFT = 37;
var ARROW_DOWN = 40;

var MarkerHandler =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(MarkerHandler, _PureComponent);

  function MarkerHandler() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, MarkerHandler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(MarkerHandler)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      layout: undefined,
      focus: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResize", function (_ref4) {
      var entry = _ref4.entry;

      if (!entry) {
        return;
      }

      _this.setState({
        layout: {
          width: entry.width,
          height: entry.height
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (x) {
      var _this$props = _this.props,
          index = _this$props.index,
          onSlide = _this$props.onSlide;

      if (onSlide) {
        onSlide(index, x);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDragEnd", function () {
      var onSlideStop = _this.props.onSlideStop;
      if (onSlideStop) onSlideStop();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function () {
      return _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function () {
      return _this.setState({
        focus: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyPress", function (e) {
      var _this$props2 = _this.props,
          step = _this$props2.step,
          bounds = _this$props2.bounds,
          animatedValues = _this$props2.animatedValues,
          incrementKeys = _this$props2.incrementKeys,
          decrementKeys = _this$props2.decrementKeys;
      if (!_this.state.focus) return;
      var value = animatedValues.x.get();
      if (incrementKeys.indexOf(e.keyCode) !== -1) value += step;else if (decrementKeys.indexOf(e.keyCode) !== -1) value -= step;else return;
      e.preventDefault();
      animatedValues.x.update(bounds.clamp(value));
    });
    return _this;
  }

  (0, _createClass2["default"])(MarkerHandler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var animatedValues = this.props.animatedValues;

      if (prevProps.position !== this.props.posed && prevProps.value === this.props.value && this.props.position !== animatedValues.x.get()) {
        this.props.animatedValues.x.update(this.props.position);
      }

      if (prevProps.disabled !== this.props.disabled) {
        if (this.props.disabled) this._unregisterListeners();else this._registerListeners();
      }
    }
  }, {
    key: "_registerListeners",
    value: function _registerListeners() {
      document.addEventListener('keydown', this.onKeyPress);
    }
  }, {
    key: "_unregisterListeners",
    value: function _unregisterListeners() {
      document.removeEventListener('keydown', this.onKeyPress);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.disabled) this._registerListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.disabled) this._unregisterListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          bounds = _this$props3.bounds,
          hitSlop = _this$props3.hitSlop,
          position = _this$props3.position,
          value = _this$props3.value,
          sliderLayout = _this$props3.sliderLayout,
          index = _this$props3.index,
          disabled = _this$props3.disabled,
          animatedValues = _this$props3.animatedValues;
      var _this$state = this.state,
          layout = _this$state.layout,
          focus = _this$state.focus;
      var zIndex = (disabled ? -1 : index) + this.props.zIndex;
      if (focus) zIndex += 100;
      return _react["default"].createElement(_reactMeasure["default"], {
        onResize: this.onResize
      }, function (_ref5) {
        var measureRef = _ref5.measureRef;
        return _react["default"].createElement(MarkerWrapper, {
          ref: measureRef,
          bounds: bounds,
          tabIndex: 0,
          zIndex: zIndex,
          hitSlop: hitSlop,
          layout: layout,
          sliderLayout: sliderLayout,
          onValueChange: {
            x: _this2.onChange
          },
          onDragEnd: _this2.onDragEnd,
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          values: animatedValues
        }, _react["default"].cloneElement(children, {
          focus: focus,
          markerState: {
            position: position,
            value: value,
            bounds: bounds
          }
        }));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return {
        layout: props.layout || state.layout
      };
    }
  }]);
  return MarkerHandler;
}(_react.PureComponent);

exports["default"] = MarkerHandler;
(0, _defineProperty2["default"])(MarkerHandler, "defaultProps", {
  zIndex: 100,
  hitSlop: 15,
  step: 1,
  incrementKeys: [ARROW_RIGHT, ARROW_UP],
  decrementKeys: [ARROW_LEFT, ARROW_DOWN]
});